export const UPDATE_METADATA = 'UPDATE_METADATA';

export function hyExUpdateMetaData(payload: any) {
  return {
    type: UPDATE_METADATA,
    payload,
  };
}
